// src/components/Sidebar/SidebarSection.jsx
import React from "react";

export default function SidebarSection({
  icon: Icon,
  label,
  collapsed,
  className = "",
  grow = false,
  children,
}) {
  return (
    <div className={`Sidebar-section ${grow ? "Sidebar-section--grow" : ""} ${className}`}>
      {!collapsed && (
        <div className="Sidebar-section-header">
          {Icon && <Icon className="Sidebar-icon" aria-hidden="true" />}
          <span className="Sidebar-label">{label}</span>
        </div>
      )}
      {children}
    </div>
  );
}
